var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      class: _vm.mergedClass,
      style: _vm.mergedStyle,
      attrs: { "aria-label": "breadcrumb" }
    },
    [
      _c("ol", { staticClass: "breadcrumb" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "breadcrumb-item", attrs: { "aria-current": "page" } },
          [
            _c("a", { attrs: { href: _vm.baseUrl + "dashboardnew" } }, [
              _vm._v("Dashboard")
            ])
          ]
        ),
        _vm._v(" "),
        _c("li", { staticClass: "ml-auto" }, [
          _c("i", {
            staticClass: "fa fa-question-circle text-gray-700",
            on: { click: _vm.openHelpModal }
          })
        ])
      ]),
      _vm._v(" "),
      _c("HelpModal", { ref: "helpModal" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("a", { attrs: { href: "#" } }, [_vm._v("Main")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }